import { useState, useEffect, useContext } from "react";
import "./projectRow.scss";
import getComponentsPrice from "../../helpers/getComponentsPrice";
import getVendorPrice from "../../helpers/getVendorPrice";
import getProjectStatus from "../../helpers/getProjectStatus";
import { UserContext } from "../../Context/UserContext";
import { useHistory } from "react-router";
import { PopOverView } from "../../components";
import { FiMoreVertical, FiChevronDown, FiChevronUp } from "react-icons/fi";
import OpportunityService from "../../api/opportunityService";
import ProjectService from "../../api/projectService";
import firebase from "../../config/firebase";
import environment from "../../config/config";
import { useAnalyticsContext, TAGS } from "../../Context/Analytics";
import { toast } from "react-toast";
import { IconButton } from "@material-ui/core";
import interactWithUSComments from "../../config/liveFirebase";
import PastDateEntryStatus from "./PastDateEntryStatus";

export default ({
  project,
  DuplicateCard,
  ArchiveCard,
  load,
  firmName,
  userName,
}) => {
  const { record } = useAnalyticsContext();

  const history = useHistory();

  const userContext = useContext(UserContext);
  const accountType = userContext.user.accountType;

  const [showContent, toggleContent] = useState(false);

  const [ongoingAmount, setongoingAmount] = useState(0); // total PO's value
  const [completedAmount, setcompletedAmount] = useState(0);
  const opportunityService = new OpportunityService();
  const [remainingTime, setRemainingTime] = useState(0);

  const updateFBRDBEditStatus = async (payload) => {
    // to set the currentUser as active user
    await firebase
      .database()
      .ref("liveBOQ/" + project.ProjectId + "/" + "editStatus/")
      // .child("editStatus")
      .set(payload);
  };

  const lastOpen = new Date().getTime();

  const openProject = async () => {
    // load();
    const projectService = new ProjectService();
    await projectService.getProjectById(project.ProjectId).then((response) => {
      projectService
        .setProject({
          ProjectId: project.ProjectId,
          lastOpen,
          // currentUser: (response.payload[0].currentUser == null || response.payload[0].currentUser == 'null') ? userContext.user.email : response.payload[0].currentUser
        })
        .then(async (res) => {
          if (res.status == 200) {
            if (accountType == "Finance") {
              history.push("/Finance/" + project.ProjectId, {
                selectedProject: {
                  ...project,
                  rooms: JSON.parse(project.Rooms),
                },
              });
            } else {
              // await updateFBRDBEditStatus({isEditing : true, currentUser : userContext.user.email, lastEdited: Date.now(), });
              history.push("/ProjectPage/" + project.ProjectId);
              record("@project_page_open_success", {
                desccription: "project page open success",
              });
            }
          } else {
            alert(res.statusMsg);
          }
        })
        .catch((e) => {
          alert("Somthing went wrong!");
          console.log("setProject API catch: ", e);
        });
    });
    load();
  };

  useEffect(() => {
    if (showContent) {
      opportunityService
        .getOpportunitiesByProjectId(project.ProjectId)
        .then((res) => {
          if (res.status === 200) {
            let tempTotalAmount = 0;
            let tempTotalSpent = 0;
            res.servicesPayload?.forEach((item) => {
              const milestoneObj = JSON.parse(item["CommonMilestones"]) || [];
              tempTotalAmount += Number(item["OrderTotalAmount"]);
              for (let mindex = 0; mindex < milestoneObj.length; mindex++) {
                if (
                  milestoneObj[mindex].name !== "Paid" &&
                  milestoneObj[mindex].payments
                ) {
                  for (
                    let pindex = 0;
                    pindex < milestoneObj[mindex].payments.length;
                    pindex++
                  ) {
                    tempTotalSpent += Number(
                      milestoneObj[mindex].payments[pindex].amount
                    );
                  }
                }
              }
              tempTotalSpent = Number(
                tempTotalSpent +
                  (milestoneObj[0].name === "Paid"
                    ? Number(milestoneObj[0].totalAmount)
                    : 0)
              );
              // });
            });
            console.log(
              "CALCULATE THE AMOUNTS",
              tempTotalAmount,
              tempTotalSpent
            );
            // setupcomingAmount(tempTotalAmount);
            setongoingAmount(tempTotalAmount);
            setcompletedAmount(tempTotalSpent);
          }
        })
        .catch((e) => {
          console.log(e);
          //     setupcomingAmount(0);
          // setongoingAmount(0);
          // setcompletedAmount(0);
        });
    }
  }, [showContent]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    // Function to check and update remaining time
    const checkRemainingTime = () => {
      interactWithUSComments("GET", `${project.ProjectId}/pastDateEntry/`, null)
        .then((response) => {
          if (response && response.data && response.data.status === true) {
            const enabledTime = response.data.timestamp;
            const currentTime = new Date().getTime();
            const elapsedTime = currentTime - enabledTime;

            // Maximum allowed time is 3 hours (in milliseconds)
            const maxTime = 3 * 60 * 60 * 1000;

            if (elapsedTime >= maxTime) {
              // If more than 3 hours have passed, set status to false
              interactWithUSComments(
                "POST",
                `${project.ProjectId}/pastDateEntry/`,
                {
                  status: false,
                  timestamp: currentTime,
                }
              );
              setRemainingTime(0);
            } else {
              // Calculate remaining time in milliseconds
              const remainingTimeMs = maxTime - elapsedTime;
              setRemainingTime(remainingTimeMs);
            }
          } else {
            setRemainingTime(0);
          }
        })
        .catch((error) => {
          console.error("Error fetching past date entry status:", error);
          setRemainingTime(0);
        });
    };

    // Check initially
    checkRemainingTime();

    // Set up interval to check every second
    const intervalId = setInterval(checkRemainingTime, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [project.ProjectId]);

  return (
    <div className="projectRow" key={project.ProjectId}>
      <div
        className="projectHeader"
        onClick={(e) => {
          load();
          // console.log('UserCOntext',userContext);
          firebase
            .database()
            .ref("liveBOQ/" + project.ProjectId.toString() + "/" + "editStatus")
            .once("value", (snapshot) => {
              //  console.log('Firebase SS', snapshot.val())
              if (snapshot.exists()) {
                let lastEditedtime = new Date(snapshot.val().lastEdited);
                // console.log('time edited',lastEditedtime,'currentTime',new Date())
                // console.log('the value',snapshot.val(),'!snapshot.val().isEditing',!snapshot.val().isEditing,'diff',(Math.abs((new Date() - lastEditedtime  ) / 1000 / 60)))
                if (
                  !snapshot.val().isEditing ||
                  Math.abs((new Date() - lastEditedtime) / 1000 / 60) > 11
                ) {
                  // console.log('opening the project ', (Math.abs((new Date() - lastEditedtime  ) / 1000 / 60)))
                  updateFBRDBEditStatus({
                    isEditing: false,
                    currentUser: null,
                    lastEdited: Date.now(),
                  });
                  openProject();
                } else if (
                  snapshot.val().currentUser === userContext.user.email
                ) {
                  // load();
                  toast.error(
                    `You Can't access You might have opened it another Tab. Please Close it First to access`,
                    {
                      backgroundColor: "red",
                      duration: 7000,
                      color: "black",
                    }
                  );
                } else {
                  // if(snapshot.val().lastEdited)
                  // console.log('timedff',Math.abs((new Date() - lastEditedtime  ) / 1000 / 60));
                  // if(Math.abs((new Date() - lastEditedtime  ) / 1000 / 60) > 11 ){
                  //   openProject();
                  // }
                  // else{
                  // console.log('not accesseble')
                  // load();
                  toast.error(
                    `You Can't access ${snapshot.val().currentUser} is Using.`,
                    {
                      backgroundColor: "red",
                      duration: 7000,
                      color: "black",
                    }
                  );
                  // }
                }
              } else {
                openProject();
              }
            });
          load();
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 5,
            marginLeft: 20,
          }}
        >
          <div
            style={{
              visibility: `${
                userContext.user.accountType === "Admin" ||
                userContext.user.accountType === "Owner"
                  ? "visible"
                  : "hidden"
              }  `,
            }}
          >
            {showContent ? (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleContent(false);
                }}
              >
                <FiChevronUp />
              </IconButton>
            ) : (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleContent(true);
                }}
              >
                <FiChevronDown />
              </IconButton>
            )}
          </div>
          <div>{project.ClientName}</div>
        </div>

        <div
          style={
            {
              color: "grey",
              border: "1px solid grey",
              padding: "3px 8px",
              borderRadius: "4px",
              maxWidth: "45px",
            }
            // : { color: "red", border: "1px solid red", padding: "3px 8px", borderRadius: "4px", maxWidth: "45px" }
          }
          onClick={(e) => {
            e.stopPropagation();
            if (environment.environment === "production") {
              window.open(
                `https://staartlive.netlify.app/?ProjectId=${project.ProjectId}&ProjectName=${project.ClientName}&firmName=${firmName}&userName=${userName}`
              );
            } else {
              window.open(
                `https://livestaart.netlify.app/?ProjectId=${project.ProjectId}&ProjectName=${project.ClientName}&firmName=${firmName}&userName=${userName}`
              );
            }

            record(
              TAGS[
                ("@live_button_click_success",
                { description: "Live button click success" })
              ]
            );
          }}
        >
          Live
        </div>

        <div
          style={
            getComponentsPrice({
              ...project,
              rooms: JSON.parse(project.Rooms),
            }) == 0
              ? {
                  textDecoration: "underline",
                  textDecorationColor: "Green",
                  textDecorationStyle: "solid",
                  textDecorationThickness: 3,
                  WebkitTextDecorationColor: "red",
                }
              : {
                  textDecoration: "underline",
                  textDecorationColor: "red",
                  textDecorationStyle: "solid",
                  textDecorationThickness: 3,
                  WebkitTextDecorationColor: "green",
                }
          }
        >
          {getComponentsPrice({
            ...project,
            rooms: JSON.parse(project.Rooms),
          }) == 0
            ? "BOQ"
            : getProjectStatus({
                ...project,
                rooms: JSON.parse(project.Rooms),
              })}
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
            record(
              TAGS[
                ("@duplicate_archive_menu_icon_click_success",
                { description: "Live button click success" })
              ]
            );
          }}
        >
          <PopOverView
            component={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: 280,
                  // backgroundColor: "#ffffff",
                  borderRadius: 6,
                  // boxShadow:
                  // "0 6px 16px rgba(0, 0, 0, 0.12), 0 3px 6px rgba(0, 0, 0, 0.08)",
                  overflow: "hidden",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                }}
              >
                {/* Menu Header - adds a professional touch */}
                <div
                  style={{
                    padding: "12px 16px",
                    borderBottom: "1px solid #f0f0f0",
                    fontSize: 14,
                    color: "#353535",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    // textTransform: "uppercase",
                  }}
                >
                  {project.ClientName}
                </div>

                {/* Menu Items Container */}
                <div style={{ padding: "8px 0" }}>
                  {/* Duplicate Option */}
                  <div
                    className="activeItem"
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      DuplicateCard(project);
                    }}
                    style={{
                      padding: "10px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      transition: "all 0.15s ease",
                      color: "#262626",
                      fontSize: 14,
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f9f9f9")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <div style={{ marginRight: 12, display: "flex" }}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
                          stroke="#595959"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
                          stroke="#595959"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div style={{ fontWeight: 500 }}>Duplicate</div>
                  </div>

                  {/* Past Date Entry Option */}
                  <div
                    className="activeItem"
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      const currentTime = new Date().getTime();
                      setRemainingTime(3 * 60 * 60 * 1000);
                      interactWithUSComments(
                        "POST",
                        `${project.ProjectId}/pastDateEntry/`,
                        {
                          status: true,
                          timestamp: currentTime,
                        }
                      );
                    }}
                    style={{
                      padding:
                        remainingTime === 0 ? "10px 16px" : "10px 16px 4px",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      transition: "all 0.15s ease",
                      color: "#262626",
                      fontSize: 14,
                      borderLeft:
                        remainingTime !== 0
                          ? "3px solid #fdd34d"
                          : "3px solid transparent",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f9f9f9")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ marginRight: 12, display: "flex" }}>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 8V12L15 15"
                            stroke={remainingTime === 0 ? "#595959" : "#fdd34d"}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                            stroke={remainingTime === 0 ? "#595959" : "#fdd34d"}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div style={{ fontWeight: 500 }}>
                        {remainingTime === 0
                          ? "Enable past date entry Staart SiteHub"
                          : "Extend period by 3 hrs"}
                      </div>
                    </div>

                    {remainingTime !== 0 && (
                      <div
                        style={{
                          margin: "8px 0 8px 30px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: "#fffcf0",
                          padding: "8px 12px",
                          borderRadius: 4,
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            color: "#8c6d11",
                            fontWeight: 500,
                          }}
                        >
                          Time remaining:
                        </div>
                        <div
                          style={{
                            fontFamily:
                              "'SF Mono', SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#594500",
                            padding: "2px 8px",
                            backgroundColor: "rgba(253, 211, 77, 0.12)",
                            borderRadius: 4,
                            border: "1px solid rgba(253, 211, 77, 0.3)",
                          }}
                        >
                          {formatTime(remainingTime)}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Revoke Option - only shows when enabled */}
                  {remainingTime !== 0 && (
                    <div
                      className="activeItem"
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        const currentTime = new Date().getTime();
                        setRemainingTime(0);
                        interactWithUSComments(
                          "POST",
                          `${project.ProjectId}/pastDateEntry/`,
                          {
                            status: false,
                            timestamp: currentTime,
                          }
                        );
                      }}
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        transition: "all 0.15s ease",
                        color: "#cf1322",
                        fontSize: 14,
                        borderLeft: "3px solid transparent",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#fff1f0";
                        e.currentTarget.style.borderLeftColor = "#ff4d4f";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.borderLeftColor = "transparent";
                      }}
                    >
                      <div style={{ marginRight: 12, display: "flex" }}>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18 6L6 18"
                            stroke="#cf1322"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6 6L18 18"
                            stroke="#cf1322"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div style={{ fontWeight: 500 }}>
                        Revoke past data entry access
                      </div>
                    </div>
                  )}

                  {/* Archive Option - Admin or Owner only */}
                  {(userContext.user.accountType === "Admin" ||
                    userContext.user.accountType === "Owner") && (
                    <>
                      <div
                        style={{
                          height: 1,
                          backgroundColor: "#f0f0f0",
                          margin: "8px 0",
                        }}
                      />

                      <div
                        className="activeItem"
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          ArchiveCard(project);
                        }}
                        style={{
                          padding: "10px 16px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          transition: "all 0.15s ease",
                          color: "#434343",
                          fontSize: 14,
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f9f9f9")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                      >
                        <div style={{ marginRight: 12, display: "flex" }}>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 7H21V21H3V7Z"
                              stroke="#595959"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V7H21V4.5C21 3.67157 20.3284 3 19.5 3Z"
                              stroke="#595959"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10 12H14"
                              stroke="#595959"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div style={{ fontWeight: 500 }}>Archive</div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            }
          >
            {/* <FiMoreVertical
              size={18}
              style={{
                position: "relative",
                color: remainingTime !== 0 ? "#fdd34d" : "currentColor",
              }}
            /> */}

            <PastDateEntryStatus
              remainingTime={remainingTime}
              formatTime={formatTime}
            />
          </PopOverView>
        </div>
      </div>
      {showContent && (
        <div
          className="projectDetails"
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              flex: 1,
            }}
          >
            <div style={{ flex: 1, fontSize: "15px", fontWeight: "600" }}>
              Total Po Value: {ongoingAmount.toFixed(0)}
            </div>
            <div style={{ flex: 1, fontSize: "15px", fontWeight: "600" }}>
              Paid Amount: {completedAmount.toFixed(0)}
            </div>
            <div style={{ flex: 1, fontSize: "15px", fontWeight: "600" }}>
              Balance :
              <span
                style={{
                  color: "darkseagreen",
                }}
              >
                {(ongoingAmount - completedAmount).toFixed(0)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
